import { useNavigate } from 'react-router-dom';
import LangSwitcher from './LangSwitcher';

/**
 * TopBar — Shared brand navigation header
 *
 * Props:
 *   showBack   {boolean}  – show arrow_back icon (default false = show logo)
 *   title      {string}   – custom title text when showBack=true
 *   dark       {boolean}  – dark bg (#1A1A2E) instead of brand orange
 *   teal       {boolean}  – success teal bg (#3DBFA0)
 *   onBack     {function} – custom back handler (defaults to navigate(-1))
 *   closeIcon  {boolean}  – show × close instead of ← arrow
 */
export default function TopBar({
  showBack = false,
  title,
  dark = false,
  teal = false,
  onBack,
  closeIcon = false,
}) {
  const navigate = useNavigate();

  let bgColor = '#FF5C35';
  if (dark) bgColor = '#1A1A2E';
  if (teal) bgColor = '#3DBFA0';

  const handleBack = () => {
    if (onBack) onBack();
    else navigate(-1);
  };

  return (
    <header
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        maxWidth: 390,
        margin: '0 auto',
        height: 56,
        backgroundColor: bgColor,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '0 16px',
        zIndex: 50,
        boxShadow: 'none',
      }}
    >
      {/* Left: back button or logo */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
        {showBack ? (
          <>
            <button
              onClick={handleBack}
              style={{
                background: 'none',
                border: 'none',
                color: '#ffffff',
                cursor: 'pointer',
                padding: '4px',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                transition: 'background 0.15s',
              }}
              aria-label="Back"
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                {closeIcon
                  ? <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
                  : <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/>
                }
              </svg>
            </button>
            {title && (
              <span style={{
                color: '#ffffff',
                fontFamily: "'Plus Jakarta Sans', sans-serif",
                fontWeight: 700,
                fontSize: 18,
                letterSpacing: '-0.02em',
              }}>
                {title}
              </span>
            )}
          </>
        ) : (
          <>
            {/* Coffee cup icon */}
            <svg width="22" height="22" viewBox="0 0 24 24" fill="white">
              <path d="M20 3H4v10c0 2.21 1.79 4 4 4h6c2.21 0 4-1.79 4-4v-3h2c1.11 0 2-.89 2-2V5c0-1.11-.89-2-2-2zm0 5h-2V5h2v3zM4 19h16v2H4z"/>
            </svg>
            <div style={{ display: 'flex', flexDirection: 'column', lineHeight: 1, gap: 1 }}>
              <span style={{
                color: '#ffffff',
                fontFamily: "'Plus Jakarta Sans', sans-serif",
                fontWeight: 700,
                fontSize: 18,
              }}>
                泡泡茶 BubbleCha
              </span>
              <span style={{
                color: 'rgba(255,255,255,0.8)',
                fontFamily: "'Plus Jakarta Sans', sans-serif",
                fontSize: 10,
                letterSpacing: '0.05em',
              }}>
                Premium Taiwanese Tea
              </span>
            </div>
          </>
        )}
      </div>

      {/* Right: language switcher */}
      <LangSwitcher />
    </header>
  );
}
